import { useEffect, useState } from "react";
import { apphistory, AppState } from "../../store";
import { AppStorage } from "../../common/app-storage";
import { BankProps } from "../../components/bank-select/bank-select.props";
import { BlueMediaService } from "../../service/bm-service";
import { AdditionalyProps, BmVerifyModel } from "./bm-verify-model";
import { BankVerificationPageProps } from "./BankVerificationPageProps";
import { blueMediaConsents } from "./cosents";
import useTextContents from '../../hooks/useTextContents'
import { KontomatikService } from "../../service/kontomatik-service";
import { AppLinks } from '../../environment/app-links'
import { SessionStorage } from '../../common/cookie-storage'
import { STORAGEKEYS } from '../../common/keys'
import { collectBikData } from '../../common/helpers/collectBikData'
import { WorkflowTypes } from '../../common/workflow'

export const useBMVerifyController = (props: BankVerificationPageProps, additionalyProps: AdditionalyProps): BmVerifyModel  => {
  const textContent = useTextContents()

  const getBikCfdData = (): { JSC: string; HDIM: string } => {
    try {
      const inputHDIM = document.getElementById('ptsuser_prefs2') as HTMLInputElement | null
      // @ts-ignore
      const JSC = window.ptadx?.ptvalidate?.('ptsuser_prefs') ?? "";
      const HDIM = inputHDIM?.value ?? "";

      return { JSC, HDIM }
    } catch {
      // Brak / błąd skryptu BIK CFD nie może blokować flow bank verification.
      return { JSC: "", HDIM: "" }
    }
  }

  const consentHandle = (m: BmVerifyModel) => (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const { id } = e.currentTarget;
    let model = { ...m };
    const index = model.consents.findIndex((p) => p.id === id);
    model.consents[index].isChecked = !model.consents[index].isChecked;
    model = validate(model);
    model = copyModel(model);
    setModel(model);
  };

  const bankHandle = (m: BmVerifyModel) => (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const { id } = e.currentTarget;
    let model = { ...m };
    model.banks.forEach((p) => (p.isSelected = false));
    const index = model.banks.findIndex((p) => p.id === id);
    model.banks[index].isSelected = true;
    model = validate(model);
    model = copyModel(model);
    setModel(model);
  };
  const createBankSelect = (id: string, url: string, bankName: string): BankProps => {
    return {
      id,
      bankName,
      imgUrl: url,
      isSelected: false,
      isSliding: false
    };
  };

  const validate = (model: BmVerifyModel) => {
    model.hasBankError = false;
    model.hasConsentError = false;
    const banksError = model.banks.find((p) => p.isSelected === true);
    if (!banksError) {
      model.hasBankError = true;
    }
    const consentError = model.consents.find((p) => p.isChecked === false);
    if (consentError) {
      model.hasConsentError = true;
    }
    return model;
  };
  const send = (m: BmVerifyModel) => (): void => {
    let model = { ...m };
    model.isSended = true;
    model = validate(model);
    model.onSend(model.hasConsentError, model.hasBankError);

    // [ZAŁOŻENIE BIZNESOWE: 83031] GDY UŻYTKOWNIK PRZECHODZI PROCES ZA POMOCĄ INTEGRATORA ZEWNĘTRZNEGO, WYSYŁAMY HDIM I JSC. W PRZYPADKU FORMULARZA OPENY, WYSYŁAMY JE NA INNYM ETAPIE
    const IS_EXTERNAL_INTEGRATOR = WorkflowTypes.isFromExternalIntegrator()
    const [HDIM, JSC] = IS_EXTERNAL_INTEGRATOR ? collectBikData() : [null, null];


    if (!model.hasBankError && !model.hasConsentError) {
      props.invokeLoading();
      const activeBank = model.banks.find(
        (p) => p.isSelected === true
      ) as BankProps;
      const service = new BlueMediaService();


      service.getVerificationUrl({
          bankId: Number.parseInt(activeBank.id),
          consents: blueMediaConsents, //HACK: skopany kod !!! ignoruje to co klinet wyklikal w UI !!!
          hdim: HDIM,
          jsc: JSC,
        })
        .then((p) => {
          if (window.open(p.url, "_self")) {
            const store = new AppStorage();
            store.clear();
          } else {
            props.getBanks();
            props.endLoading();
          }
        })
        .catch(err => {
          props.endLoading();
        });
    }
    model = copyModel(model);
    setModel(model);
  };

  const sendKontomatikSession = (m: BmVerifyModel) => (target: string, sessionId: string, sessionIdSignature: string): void => {
    let model = { ...m };
    model.isSended = true;
    const sessionStorage = new SessionStorage();
    
    // [ZAŁOŻENIE BIZNESOWE: 83031] GDY UŻYTKOWNIK PRZECHODZI PROCES ZA POMOCĄ INTEGRATORA ZEWNĘTRZNEGO, WYSYŁAMY HDIM I JSC. W PRZYPADKU FORMULARZA OPENY, WYSYŁAMY JE NA INNYM ETAPIE
    const IS_EXTERNAL_INTEGRATOR = WorkflowTypes.isFromExternalIntegrator()
    const [HDIM, JSC] = IS_EXTERNAL_INTEGRATOR ? collectBikData() : [null, null];

    {
      props.invokeLoading();
      const service = new KontomatikService();
      service
        .setSessionData({
          sessionId: sessionId,
          sessionIdSignature: sessionIdSignature,
          bankName: target,
          hdim: HDIM,
          jsc: JSC,
        })
        .then((p) => {
          sessionStorage.add(STORAGEKEYS.IS_AFTER_BANK_VERIFICATION, "true")
          apphistory.push(AppLinks.bmWaiting);
        }).catch(err => {
          props.endLoading();
        });
    }
    model = copyModel(model);
    setModel(model);
  };

  const copyModel = (copy : BmVerifyModel) =>{
    var newModel: BmVerifyModel = {
      consents: copy.consents,
      banks: copy.banks,
      send: () => { },
      sendKontomatikSession: (target: string, sessionId: string, sessionIdSignature: string) => { },
      onSend : additionalyProps.onSend,
      hasConsentError: copy.hasConsentError,
      isSended: copy.isSended,
      hasBankError: copy.hasBankError,
    };
    newModel.send = send(newModel);
    newModel.sendKontomatikSession = sendKontomatikSession(newModel);

    newModel.consents.forEach((element) => {
      element.handleChangeStatus = consentHandle(newModel);
    });
    newModel.banks.forEach((element) => {
      element.handleChange = bankHandle(newModel);
    });
    return newModel;
  }
  const convertDtoToBanks = (): BankProps[] => {
    const banks: BankProps[] = [];
    props.banks.forEach((p) =>
      banks.push(createBankSelect(p.bankId, p.logoUrl, p.bankName))
    );
    return banks;
  };
  
  const [pageModel, setModel] = useState<BmVerifyModel>(copyModel({
    consents: [
      {
        id: "1",
        isChecked: false,
        consentText: textContent('bmVerifyPage.bmConsents.consent_1'),
        handleChangeStatus: (e: any) => { },
        hasConsentError: false,
        isSended: false,
      },
      {
        id: "2",
        isChecked: false,
        consentText: textContent('bmVerifyPage.bmConsents.consent_2'),
        handleChangeStatus: (e: any) => { },
        hasConsentError: false,
        isSended: false,
      },
    ],
    banks: convertDtoToBanks(),
    isSended: false,
    hasConsentError: false,
    hasBankError: false,
    send: () => { },
    sendKontomatikSession: (target: string, sessionId: string, sessionIdSignature: string) => { },
    onSend : additionalyProps.onSend,
  }));

  useEffect(() => {
    props.getBanks();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (props.banks.length > 0) {
      const copy = { ...pageModel };
      copy.banks = convertDtoToBanks();
      setModel(copyModel(copy));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.banks]);
  useEffect(() => {
    if (pageModel.isSended) {
      const model = { ...pageModel };
      setModel(copyModel(model));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageModel.isSended]);

  return pageModel;
};

